import * as React from 'react'

export const SEND_TO_MARKETING_VALUE = '__MARKETING__'

interface RecipientCheckboxProps {
  value: string | undefined | null
  title: string
  formFields: any
  setFormFields: (fields: any) => void
}

export default function RecipientCheckbox({ value, title, formFields, setFormFields }: RecipientCheckboxProps) {
  if (value === undefined || value === null) {
    return null
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const recipients = e.target.checked ? [...formFields.recipients, value] : formFields.recipients.filter(a => a !== value)
    setFormFields({ ...formFields, recipients })
  }

  const showValue = value !== SEND_TO_MARKETING_VALUE

  return (
    <label className="pl-0 form-check form-check-valigned message-popup-recipient">
      <input
        type="checkbox"
        name="message[recipients][]"
        value={value}
        checked={formFields.recipients.includes(value)}
        onChange={handleCheckboxChange}
      />
      {title}{showValue && ` (${value})`}
    </label>
  )
}
